import React from "react";
import { useAtomValue } from "jotai";
import { gamePopState } from "@stores/popup";
import Game from "@popups/Game";

const GameContainer = () => {
  const state = useAtomValue(gamePopState);
  return state.open ? <Game /> : null;
};

export default GameContainer;
